<template>
    <div :class="['solid-box', styleType === 'two-title' ? '-two-title' : '']">
        <div v-if="!secondTitle" class="title-box up-center">
            <p class="title">{{ title }}</p>
            <p
                v-if="priceRate && ctype === 1 && priceRate !== '0%'"
                class="title _title"
            >
                最高溢价率：{{ priceRate }}
            </p>
        </div>
        <template v-else>
            <div class="title-list">
                <div class="item">{{ title }}</div>
                <div class="item">{{ secondTitle }}</div>
            </div>
        </template>
        <div class="body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import eventHub from '@/utils/eventHub'
/**
 * 内容框
 */
export default {
    props: {
        /**
         * 标题
         */
        title: {
            type: String,
            default: ''
        },
        /**
         * 第二个标题
         */
        secondTitle: {
            type: String,
            default: ''
        },
        /**
         * 最高溢价率
         */
        priceRate: {
            type: String,
            default: ''
        },
        /**
         * 样式类型
         * normal | two-title
         */
        styleType: {
            type: String,
            default: 'normal'
        }
    },
    data() {
        return {
            ctype: 1
        }
    },
    mounted() {
        eventHub.$on('areaChange', (data) => {
            if (data && data.ctype) {
                this.ctype = data.ctype
            }
        })
    }
}
</script>

<style scoped lang="scss">
.solid-box {
    // padding-top: 1px;
    height: 319px;
    // background-size: 100% 100%;
    // background-repeat: no-repeat;
    // background-image: url('../assets/images/solid_box.png');
    box-sizing: border-box;
    position: relative;

    &.-two-title {
        width: 100%;
        background-image: url('../assets/images/solid_box.png');
    }

    > .title-box {
        font-family: PingFangSC-Medium;
        width: calc(100% - 42px);
        height: 41px;
        margin: 6px 20px 0 22px;

        p.title {
            font-size: 20px;
            color: #40b9f6;
            flex: 5;
            line-height: 41px;
        }

        p._title {
            flex: unset;
            text-align: right;
        }
    }

    > .title-list {
        margin-top: 8px;
        font-family: PingFangSC-Medium;
        height: 41px;
        font-size: 22px;
        text-align: center;
        color: #fff;
        line-height: 41px;
        display: flex;

        > .item {
            text-align: center;
            flex-basis: 340px;
            flex-shrink: 0;

            &:first-child {
                margin-left: 54px;
                margin-right: 43px;
            }
        }
    }
}
</style>
